var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlayPause(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.508 71.406C31.879 54.283 0 68.656 0 96.027V415.973C0 443.344 31.879 457.715 52.508 440.594L244.531 280.621C259.781 267.748 259.781 244.252 244.531 231.379L52.508 71.406ZM352 64H351.969C334.297 64 319.969 78.326 319.969 96V416C319.969 433.672 334.297 448 351.969 448H352C369.674 448 384 433.672 384 416V96C384 78.326 369.674 64 352 64ZM480 64H479.969C462.297 64 447.969 78.326 447.969 96V416C447.969 433.672 462.297 448 479.969 448H480C497.674 448 512 433.672 512 416V96C512 78.326 497.674 64 480 64Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayPause);
export default __webpack_public_path__ + "static/media/play-pause.71bdb8e9b698f9b938fae3d932f06bb0.svg";
export { ForwardRef as ReactComponent };